<template>
  <div class="exam-timer text-secondary-500 lg:my-3 block text-center">
    <div class="block lg:hidden text-sm font-semibold">{{ timeLeftFormatted }}</div>
    <div role="progressbar" class="hidden lg:grid mx-auto" :aria-valuenow="timeLeftFormatted" aria-valuemin="0" aria-valuemax="100" :style="'--value:' + timeLeftPercentage">
      {{ timeLeftFormatted }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamTimer',

  props: {
    exam: Object,
    test: Object,
  },

  data() {
    return {
      minutesLeft: null,
    }
  },

  computed: {
    timeLeftFormatted: function () {
      var hours = Math.floor(this.minutesLeft / 60)
      var minutes = this.minutesLeft % 60
      if( minutes < 10 ) {
        minutes = '0' + minutes
      }
      return hours + ':' + minutes + 'h'
    },

    timeLeftPercentage: function() {
      return Math.floor( 100 / this.exam.max_time * this.minutesLeft )
    },
  },

  mounted() {
    this.minutesLeft = this.test.minutes_left
    this.checkIfExceeded()
  },

  methods: {

    checkIfExceeded() {
      if (this.minutesLeft > 0) {
        setTimeout(() => {
          this.minutesLeft -= 1
          this.checkIfExceeded()
        }, 1000 * 60)
      }
    },
  },

}
</script>

<style scoped>
@keyframes growProgressBar {
  0%, 33% { --pgPercentage: 0; }
  100% { --pgPercentage: var(--value); }
}

@property --pgPercentage {
  syntax: '<number>';
  inherits: false;
  initial-value: 0;
}

div[role="progressbar"] {
  --size: 80px;
  --fg: var(--secondary);
  --bg: #f3f4f6;
  --pgPercentage: var(--value);
  animation: growProgressBar 3s 1 forwards;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  place-items: center;
  background:
      radial-gradient(closest-side, var(--bg) 80%, transparent 0 99.9%, var(--bg) 0),
      conic-gradient(var(--fg) calc(var(--pgPercentage) * 1%), var(--bg) 0)
;
  font-family: Helvetica, Arial, sans-serif;
  font-size: calc(var(--size) / 4.5);
  color: var(--fg);
}
</style>
